export class TrainingSessionCompanyHistoryStudent {
    constructor(
        public id?: number,
        public firstname?: string,
        public lastname?: string,
        public averageEvaluation?: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/history/student/training-session-company-history-student.ts